module.exports = __webpack_public_path__ + "img/stop.c07cf43e.png";